import axiosInstance from "./axiosInstance";

export async function createDeviden(data) {
  return await axiosInstance.post("/penyertaan-modal-deviden", data);
}

export async function updateDeviden(data) {
  return await axiosInstance.put("/penyertaan-modal-deviden", data);
}

